import React, { useState } from "react"
import { Flex } from "antd"
import ClientProfileHeader from "./Header"
import ClientProfileTabs from "./Tabs"

const ClientProfile = () => {
  const [activeKey, setActiveKey] = useState("1")

  return (
    <Flex vertical>
      <ClientProfileHeader />
      <ClientProfileTabs activeKey={activeKey} setActiveKey={setActiveKey} />
    </Flex>
  )
}

export default ClientProfile
